import VideoInputManager, {
  VideoItem,
} from "@/components/video-input-manager.tsx";
import { FileUpload } from "@/components/ui/file-upload.tsx";

type Props = {
  setImg: (data: any) => void;
  setVideos: React.Dispatch<React.SetStateAction<VideoItem[]>>;
  videos: VideoItem[];
  images?: File[];
};

export const AnimalMediaInfo = ({ setImg, setVideos, videos, images }: Props) => {
  // const [ preview, setPreview ] = useState<string | null> (
  // null )
  return (
    <div className={"flex flex-col gap-4"}>
      <FileUpload
        files={images}
        onFilesChange={setImg}
      />
      <VideoInputManager setVideos={setVideos} videos={videos} />
    </div>
  );
};
